import requestApi from "@/utils/requestApi";
import requestSC from "@/utils/requestSC";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import moment from "moment";

export default {
  data() {
    return {
      form: {
        delivery: "",
        planPeriod: "7",
        goodsIdList: [],
      },
      list: [],
      dateList: [],
      goodsList: [],
      // 待确认订单汇总
      confirming: {},
    };
  },

  mounted() {
    requestApi.post(`sctrading/order/mj/confirm/count`, {}).then((res) => {
      if (res.code == "0") {
        this.confirming = res.data;
      } else {
        this.$message.error(res.msg);
      }
    });
    requestSC.get(`rest/mj/goods/seq/spu/list?size=9999&current=1`).then((res) => {
      this.goodsList = res.data.records || [];
    });
    this.loadData();
  },

  methods: {
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        customClass: "seller-style",
      });

      const {
        msg,
        code,
        data: { date, data },
      } = await requestApi.post(`sctrading/order/mj/plan`, this.form);
      loading.close();

      if (code == "0") {
        this.dateList = date;
        const list = [];
        data.forEach((item) => {
          let total = 0;
          const listItem = {
            goods: item.name,
          };
          item.quantity.forEach((quantityItem, quantityIndex) => {
            total += Number(quantityItem);
            listItem[`d${date[quantityIndex]}`] = quantityItem;
          });
          listItem.total = Number(total.toFixed(3));
          list.push(listItem);
        });
        this.list = list;
      } else {
        this.$message.error(msg);
      }
    },

    exportDownload() {
      const { list } = this;
      if (!list.length) {
        this.$message.warning("暂无导出数据");
        return;
      }

      let tableEle = document.querySelector(".table");
      if (!tableEle) return;
      //用div复制一遍要打印的表格dom
      let div = document.createElement("div");
      div.innerHTML = tableEle.innerHTML;
      //因为添加fixed属性，elementUI底层会把table的dom创建两份，通过一份隐藏一份显示来实现交互，我们打印时需要去掉多余的一份el-table__fixed
      let fixedLeft = div.querySelector(".el-table__fixed");
      if (fixedLeft) fixedLeft.remove();
      let fixedRight = div.querySelector(".el-table__fixed-right");
      if (fixedRight) fixedRight.remove();
      const wb = XLSX.utils.table_to_book(div);
      const cols = [
        {
          wch: 40,
        },
      ];
      this.dateList.forEach(() => {
        cols.push({
          wch: 15,
        });
      });
      cols.push({
        wch: 15,
      });
      wb.Sheets.Sheet1["!cols"] = cols;
      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `排产计划(订单提货/发货计划)${moment().format("YYYY-MM-DD")}.xlsx`);
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    dateChange(tab) {
      this.form.planPeriod = tab.name;

      this.loadData();
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    submitForm() {
      this.loadData();
    },
  },
};
